/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Composer_SendInputs */

const en_chat_composer_send = /** @type {(inputs: Chat_Composer_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

const pt_br2_chat_composer_send = /** @type {(inputs: Chat_Composer_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar`)
};

/**
* | output |
* | --- |
* | "Send" |
*
* @param {Chat_Composer_SendInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const chat_composer_send = /** @type {((inputs?: Chat_Composer_SendInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Composer_SendInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_composer_send(inputs)
	return pt_br2_chat_composer_send(inputs)
});